import { render, staticRenderFns } from "./UserSettingsManager.vue?vue&type=template&id=4b1cad39&scoped=true&"
import script from "./UserSettingsManager.vue?vue&type=script&lang=ts&"
export * from "./UserSettingsManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1cad39",
  null
  
)

export default component.exports